export const BOOLEAN_TYPES = [
  { type: 'yes_label', value: true },
  { type: 'no_label', value: false }
];